
import ogPagesMixins from '@/mixins/ogPagesMixins'
import isClient from '@/mixins/isClient'
export default {
  mixins: [ogPagesMixins, isClient],
  scrollToTop: true,
  props: {
    author: {
      type: Object,
      default: null,
    },
    subscriptions: {
      type: Object,
      default: null,
    },
    seoAuthorName: {
      type: String,
      default: '',
    },
  },
  computed: {
    seoImage() {
      return {
        url: `https://api.megasreda.ru/image/ogimage/author/${this.author?.id}.jpg`,
        urlVk: `https://api.megasreda.ru/image/ogimage/author/vk/${this.author?.id}.jpg`,
        urlTw: `https://api.megasreda.ru/image/ogimage/author/${this.author?.id}.jpg`,
        type: 'image/jpeg',
        width: 1200,
        height: 630,
      }
    },
    isUserHasSubscriptions() {
      return (
        this.subscriptions?.streams?.length ||
        this.subscriptions?.companys?.length ||
        this.subscriptions?.users?.length
      )
    },
    seoTitle() {
      return `${this.seoAuthorName}: подписка | Мегасреда`
    },
    seoDescription() {
      return `Все активные подписки ${
        this.author.type === 'COMPANY' ? 'компании' : 'пользователя'
      } ${this.seoAuthorName} на Мегасреде`
    },
    seoH1() {
      return `Подписка ${
        this.author.type === 'COMPANY' ? 'компании' : 'пользователя'
      } ${this.seoAuthorName} на журналы и авторов Мегасреды`
    },
  },
  methods: {
    updateItem() {
      this.$emit('update-subscription')
    },
  },
}
